import styled from '@emotion/styled';

import { NavigationHeader } from './components/';
import { TopLine } from './components/TopLine';

export const TopHeader = () => {
  return (
    <Root>
      <TopLine />
      <NavigationHeader />
    </Root>
  );
};

const Root = styled.div`
  margin-bottom: 30px;
`;
